/**
 * Wie neu eine App sein muss, damit der Server ihren Abgleich annimmt
 * (26.10.2026).
 *
 * Am 26.10. leerte ein Gerät mit einer älteren Fassung die Einkaufsliste
 * beim Server: Es kannte die Verschlüsselung nicht, legte das Geholte als
 * leere Hülle ab und schickte sie später neu. Eine Web-App aktualisiert sich
 * nicht von allein, und ein Gerät, das wochenlang nicht neu lädt, schreibt
 * mit alten Regeln weiter. Deshalb trägt jede Anfrage die Fassung ihres
 * Abgleichs mit, und der Server weist zu alte ab — die Änderungen bleiben in
 * der Outbox, bis das Gerät neu geladen hat.
 *
 * **Hochzählen**, sobald ältere Geräte mit dem neuen Stand Falsches anrichten
 * würden (neue verschlüsselte Tabelle, geänderte Bedeutung eines Felds), und
 * `MIN_CLIENT_PROTOCOL` mitziehen.
 */
/**
 * Fassungen:
 * - 2 (26.10.2026): Hüllen nie neu verschlüsseln, leerer Inhalt zurückgehalten.
 * - 3 (27.10.2026): Übungen, Plan-Übungen, Läden, Markierungen an Abo-Terminen
 *   und Körperwerte im Profil verschlüsselt. Eine Fassung 2 kennte sie nicht,
 *   schickte sie als Klartext (abgewiesen) und legte Geholtes als leere Hülle ab.
 * - 4 (28.10.2026): Tagesprotokoll (`food_log`) verschlüsselt. Eine Fassung 3
 *   schickte es als Klartext (abgewiesen) und legte Geholtes als Hülle ohne
 *   Namen und Kalorien ab — der Tag sähe leer aus.
 */
export const CLIENT_PROTOCOL = 4;
export const MIN_CLIENT_PROTOCOL = 4;
export const CLIENT_HEADER = 'X-Kraftwerk-Client';
/** Grund im 426: diese Fassung ist zu alt. */
export const UPDATE_REQUIRED_REASON = 'update';

/** Nimmt der Server eine Anfrage mit diesem Kopf an? Ohne Kopf: nein. */
export function clientIsCurrent(header: string | null | undefined): boolean {
  if (!header || !/^\d{1,6}$/.test(header)) return false;
  return Number(header) >= MIN_CLIENT_PROTOCOL;
}
